import { PsychomotorIndex } from 'apps/web/enums/iPlanObjectives/categories.enum';
import { BehavioralVerb } from 'apps/web/types/labelled-collection.type';

import * as digital from './digital';
import * as standard from './standard';

export const createPsychomotorCategoryLabels = () => [
  'Origination',
  'Adaptation',
  'Complex Overt Response',
  'Mechanism',
  'Guided Response',
  'Set',
  'Perception',
];

export const getPsychomotorVerbs = (
  isDigital: boolean,
): Record<number, BehavioralVerb[]> => {
  return isDigital
    ? {
        [PsychomotorIndex.Perception]: digital.DIGITAL_PERCEPTION_VERBS,
        [PsychomotorIndex.Set]: digital.DIGITAL_SET_VERBS,
        [PsychomotorIndex.GuidedResponse]:
          digital.DIGITAL_GUIDED_RESPONSE_VERBS,
        [PsychomotorIndex.Mechanism]: digital.DIGITAL_MECHANISM_VERBS,
        [PsychomotorIndex.ComplexOvertResponse]:
          digital.DIGITAL_COMPLEX_OVERT_RESPONSE_VERBS,
        [PsychomotorIndex.Adaptation]: digital.DIGITAL_ADAPTATION_VERBS,
        [PsychomotorIndex.Origination]: digital.DIGITAL_ORIGINATION_VERBS,
      }
    : {
        [PsychomotorIndex.Perception]: standard.STANDARD_PERCEPTION_VERBS,
        [PsychomotorIndex.Set]: standard.STANDARD_SET_VERBS,
        [PsychomotorIndex.GuidedResponse]:
          standard.STANDARD_GUIDED_RESPONSE_VERBS,
        [PsychomotorIndex.Mechanism]: standard.STANDARD_MECHANISM_VERBS,
        [PsychomotorIndex.ComplexOvertResponse]:
          standard.STANDARD_COMPLEX_OVERT_RESPONSE_VERBS,
        [PsychomotorIndex.Adaptation]: standard.STANDARD_ADAPTATION_VERBS,
        [PsychomotorIndex.Origination]: standard.STANDARD_ORIGINATION_VERBS,
      };
};
